import React from 'react';
import { CTAButton } from './CTAButton';
export function EmotionalCTA() {
  return <section className="py-20 bg-white text-center" data-id="element-71">
      <div className="max-w-3xl mx-auto px-4" data-id="element-72">
        <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6" data-id="element-73">
          No tenés que decidir nada para siempre. <br data-id="element-74" />
          <span className="text-red-600" data-id="element-75">Solo dar un paso ahora.</span>
        </h2>

        <p className="text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-76">
          Empezar a leer puede ser el primer gesto de cuidado propio en mucho
          tiempo.
        </p>

        <CTAButton text="Quiero empezar a leer ahora" data-id="element-77" />
      </div>
    </section>;
}